import ItineraryPriceLoader, {
    type ItineraryPriceLoaderFactory,
    type PriceObject,
} from '../ItineraryPriceLoader';
import { TripType } from '@utils/trip';
import { HotelRoomApiApiHotelRoomMinPriceGet } from '@clients/HotelApi';

export default class HotelPriceLoader extends ItineraryPriceLoader {
    constructor(
        params: Omit<
            ItineraryPriceLoaderFactory,
            'tripType' | 'infantCount' | 'to'
        >
    ) {
        super({
            ...params,
            tripType: TripType.OneWay,
        });
    }

    override async fetchSinglePrices(
        start: Date,
        end: Date,
        from: string
    ): Promise<PriceObject[]> {
        const { data } = await HotelRoomApiApiHotelRoomMinPriceGet({
            cityId: Number(from),
            start: start.toISOString(),
            end: end.toISOString(),
            adultCount: this.adultCount,
            childCount: this.childCount,
            roomCount: this.roomCount,
        });
        return (
            data.dayByDayPrices?.reduce((all: PriceObject[], current) => {
                if (current.date && current.price) {
                    all.push({
                        date: dayConfig
                            .gregory(current.date)
                            .format(formatter()),
                        value: current.price,
                    });
                }
                return all;
            }, [] as PriceObject[]) || []
        );
    }
}
